import { render, staticRenderFns } from "./WorkTaskView.vue?vue&type=template&id=13832754&scoped=true"
import script from "./WorkTaskView.vue?vue&type=script&lang=js"
export * from "./WorkTaskView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13832754",
  null
  
)

export default component.exports